import React from "react";
import { Link } from "react-router-dom";
import logoBlue from '../../assets/images/logo-colored.png'

const NotFoundPage = () => {
  return (
    <div className="h-screen w-screen flex flex-col justify-between">
      <div className="flex items-center flex-1">
        <div className="container flex flex-col md:flex-row items-center justify-between px-40 text-gray-700">
          <div className="w-full lg:w-1/2 mx-8">
            <div className="text-7xl text-primary font-extrabold">404</div>
            <div className="text-7xl text-primary font-extrabold">Page Not Found!</div>
            <p className="text-xl md:text-2xl font-light leading-normal mb-8">
              We're sorry, the page you requested could not be found. Please go back to homepage!
            </p>

            <Link
              to="/"
              className="px-5 inline py-3 text-sm font-medium leading-5 shadow-2xl text-white transition-all duration-400 border border-transparent rounded-lg focus:outline-none bg-primary">
              Back to Homepage
            </Link>
          </div>
          <div className="w-full lg:flex lg:justify-end lg:w-1/2 mx-5 my-12">
            <img
              src="https://user-images.githubusercontent.com/43953425/166269493-acd08ccb-4df3-4474-95c7-ad1034d3c070.svg"
              alt="Page not found"
            />
          </div>
        </div>
      </div>
      <div className="flex justify-center items-end">
        <div className="aspect-[3.125/1.25] w-[20.75rem] lg:w-[20.75rem] relative">
          <img
            src={logoBlue}
            alt="Milestone Logo"
            className="object-contain absolute inset-0 w-full h-full"
          />
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
